import BannerUtils from '../BannerUtils.js';

class BannerAd {
    setup(
        tagName,
        adObj,
        appNexusData,
        allowedTakeoverTags,
        allowedSSANativeTags
    ) {
        this._tagName = tagName;
        this._adObj = adObj;
        this._container = this.getBannerContainer();
        this._styledVisible = false;
        this._appNexusData = appNexusData;
        this._allowedTakeoverTags = allowedTakeoverTags;
        this._allowedSSAProductTags = allowedSSANativeTags;
    }

    getBannerObj() {
        return this._adObj;
    }

    getBannerContainer() {
        const ele = BannerUtils.getElementByAdPosition(this._tagName);
        return ele ? ele.parentNode : null;
    }

    isInViewport(extraOffset) {
        const elem = this.getBannerContainer();
        const width = elem.offsetWidth;
        const height = elem.offsetHeight;
        const boxTop = elem.offsetTop - extraOffset;
        const boxLeft = elem.offsetLeft - extraOffset;
        const boxBottom = elem.offsetTop + height + extraOffset;
        const boxRight = elem.offsetLeft + width + extraOffset;

        const consumedPageLength = window.pageYOffset + window.innerHeight;
        const consumedPageWidth = window.pageXOffset + window.innerWidth;

        return (
            boxTop < consumedPageLength &&
            boxLeft < consumedPageWidth &&
            boxBottom > window.pageYOffset &&
            boxRight > window.pageXOffset
        );
    }

    isStyledVisible() {
        return this._styledVisible;
    }

    /** Specialized by children **/

    render() {}
}

export default BannerAd;



// WEBPACK FOOTER //
// ./services/banner2/types/BannerAd.js